import axios from 'axios';

// Deteksi environment API base URL
const CURRENT_ORIGIN = typeof window !== 'undefined' ? window.location.origin : '';
const IS_VERCEL_DEV = process.env.REACT_APP_VERCEL_DEV === 'true' || CURRENT_ORIGIN.startsWith('http://localhost:3000');

// Prioritas: env var manual > vercel dev / production same-origin > default localhost:3002
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'production' || IS_VERCEL_DEV
    ? CURRENT_ORIGIN
    : 'http://localhost:3002');

axios.defaults.baseURL = API_BASE_URL;

// Helper function for fetch with base URL
export const fetchWithBaseURL = async (url: string, options?: RequestInit) => {
  const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}${url}`;
  return fetch(fullUrl, options);
};

// API configuration
export const API_ENDPOINTS = {
  GOR: `/api/bookings`,
  GOR_DETAIL: (id: string) => `/api/bookings/${id}`,
  BOOKINGS: `/api/bookings`,
  MEMBERSHIP: `/api/bookings?action=membership`,
  MEMBERSHIP_STATUS: `/api/bookings?action=membership-status`,
  MEMBERSHIP_AND_BOOKING: `/api/bookings?action=membership-and-booking`,
  HOME_PAGE_DATA: `/api/bookings?action=home-page-data`,
  ALL_BOOKING_DATA: `/api/bookings?action=all-booking-data`,
  PAYMENT: `/api/payment/snap-token`,
  GOR_BOOKINGS: (id: string) => `/api/bookings/${id}/bookings`,
  INTERNAL_TOURNAMENT_CONFIG: `/api/bookings?action=internal-tournament-config`,
  INTERNAL_TOURNAMENT_REGISTER: `/api/bookings?action=internal-tournament-register`,
  INTERNAL_TOURNAMENT_REGISTRATIONS: `/api/bookings?action=internal-tournament-registrations`,
};